/* eslint-disable */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderITOfficerPage from "../RenderITOfficerPage";
import UploadCard from "../components/UploadCard";

/**
 * UPNMG staff fund contributions. Same sheet format as UploadFunds — the backend
 * tags these rows member_type='STAFF' so they stay out of the member figures.
 */
function UploadStaffFunds() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleUpload = async (file) => {
    setIsLoading(true);
    setResponse(null);
    try {
      const formData = new FormData();
      formData.append("file", file);
      await axiosInstance.post("/funds/staff/upload", formData);
      setResponse({ state: "SUCCESS", message: "Staff contributions uploaded successfully. Processing in background." });
      toast.success("Staff contributions uploaded successfully");
    } catch (e) {
      const msg = e?.response?.data?.message ?? "Upload failed. Try again.";
      setResponse({ state: "ERROR", message: msg });
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderITOfficerPage title="Upload Staff Funds">
      <UploadCard
        title="Upload Staff Fund Contributions"
        description="Upload an Excel or CSV file of fund contributions for UPNMG staff. Same columns as the member sheet — these records are kept separate from member contributions."
        onUpload={handleUpload}
        isLoading={isLoading}
        response={response}
        accentColor="purple"
      />
      <ToastContainer autoClose={3000} />
    </RenderITOfficerPage>
  );
}

export default UploadStaffFunds;
